(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lz-discovery-nudge"] && !Shopify.designMode) return;
  try {
    (() => {
  const panel = document.querySelector('.lz-discovery-nudge');
  if (!panel) return;
  let finished = false;
  let timer;
  function dismiss() {
    panel.hidden = true;
    finished = true;
    clearTimeout(timer);
  }
  function reveal() {
    if (finished) return;
    const checkout = document.querySelector('#headless-iframe');
    if (document.hidden || document.querySelector('dialog[open]') || (checkout && checkout.getBoundingClientRect().height > 0)) {
      timer = setTimeout(reveal, 500);
      return;
    }
    panel.hidden = false;
    finished = true;
  }
  panel.querySelector('button').addEventListener('click', dismiss);
  panel.querySelector('a').addEventListener('click', dismiss);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden) dismiss();
  });
  timer = setTimeout(reveal, Math.max(0, 20000 - performance.now()));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lz-product-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lz-product-gallery'))customElements.define('lz-product-gallery',class extends HTMLElement{
 connectedCallback(){
  if(this.dataset.ready)return;this.dataset.ready='true';
  const track=this.querySelector('.lz-gallery__track'),thumbs=[...this.querySelectorAll('[data-index]')],dialog=this.querySelector('dialog');
  const position=()=>Math.max(0,Math.min(thumbs.length-1,Math.round(track.scrollLeft/track.clientWidth)));
  const select=i=>track.scrollTo({left:Math.max(0,Math.min(thumbs.length-1,i))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  track.addEventListener('scroll',()=>{const i=position();thumbs.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));this.querySelector('.lz-gallery__count').textContent=`${i+1} / ${thumbs.length}`;},{passive:true});
  this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-index'))select(Number(b.dataset.index));if(b.hasAttribute('data-step'))select(position()+Number(b.dataset.step));if(b.hasAttribute('data-full')){dialog.querySelector('img').src=b.dataset.full;dialog.showModal();}if(b.hasAttribute('data-close'))dialog.close();});
  dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lz-scroll-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    const selectors = [
      '.lz-home__statement h2',
      '.lz-home__statement > p:last-child',
      '.lz-home__section-heading h2',
      '.lz-home__section-heading > p:last-child',
      '.lz-home__purchase > div:first-child > h2',
      '.lz-home__purchase > div:first-child > p:last-child',
      '.lz-home__close h2',
      '.lz-world__copy .lz-display',
      '.lz-world__copy .lz-lede',
      '.lz-notes .lz-display',
      '.lz-notes__grid h3',
      '.lz-notes__grid article > p:last-child',
      '.lz-proof .lz-display',
      '.lz-proof .lz-lede',
      '.lz-wrap > .lz-layering > p:nth-child(2):not(:has(strong, a))',
      '.lz-layering + .lz-kicker + .lz-display',
      '.lz-layering + .lz-kicker + .lz-display + .lz-lede'
    ].join(',');
    if (!window.requestAnimationFrame || !window.matchMedia) return;
    if (document.documentElement.classList.contains('shopify-design-mode')) return;

    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const desktop = window.matchMedia('(min-width: 990px)');
    const registered = new WeakSet();
    const pending = new Map();
    const getRoot = () => desktop.matches ? document.querySelector('.page-wrapper') : null;
    let root = getRoot();
    let scrollTarget = root || document;
    let frame = 0;

    const finish = (element) => {
      element.setAttribute('data-lz-reveal', 'complete');
      element.style.removeProperty('--lz-reveal-progress');
      pending.delete(element);
    };

    const update = () => {
      frame = 0;
      if (preference.matches) return;
      const bounds = root ? root.getBoundingClientRect() : { top: 0, bottom: window.innerHeight, height: window.innerHeight };
      const measurements = [...pending.keys()].map(element => {
        const previous = pending.get(element) || 0;
        const rect = element.getBoundingClientRect();
        const top = rect.top - (1 - previous) * 10;
        const progress = Math.max(previous, Math.min(1, Math.max(0, (bounds.bottom - bounds.height * .1 - top) / (bounds.height * .32))));
        const fullyVisible = rect.top >= bounds.top && rect.bottom <= bounds.bottom - bounds.height * .05;
        return { element, progress, fullyVisible, passed: rect.bottom <= bounds.top };
      });
      measurements.forEach(({ element, progress, fullyVisible, passed }) => {
        if (!element.isConnected || progress >= 1 || fullyVisible || passed) {
          finish(element);
        } else {
          pending.set(element, progress);
          element.style.setProperty('--lz-reveal-progress', progress.toFixed(4));
        }
      });
    };

    const schedule = () => {
      if (!frame && pending.size) frame = window.requestAnimationFrame(update);
    };

    const rebind = () => {
      scrollTarget.removeEventListener('scroll', schedule);
      root = getRoot();
      scrollTarget = root || document;
      scrollTarget.addEventListener('scroll', schedule, { passive: true });
      schedule();
    };

    const initialise = (root = document) => {
      if (preference.matches) return;
      const bounds = getRoot()?.getBoundingClientRect() || { bottom: window.innerHeight, height: window.innerHeight };
      root.querySelectorAll(selectors).forEach(element => {
        if (registered.has(element) || element.querySelector('a, button, input, strong')) return;
        registered.add(element);
        if (element.getBoundingClientRect().top <= bounds.bottom - bounds.height * .1) return;
        pending.set(element, 0);
        element.style.setProperty('--lz-reveal-progress', '0');
        element.setAttribute('data-lz-reveal', 'pending');
      });
      schedule();
    };

    preference.addEventListener('change', () => {
      if (preference.matches) {
        [...pending.keys()].forEach(finish);
        if (frame) window.cancelAnimationFrame(frame);
        frame = 0;
      } else {
        initialise();
      }
    });
    scrollTarget.addEventListener('scroll', schedule, { passive: true });
    desktop.addEventListener('change', rebind);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('focusin', event => {
      const element = event.target.closest('[data-lz-reveal="pending"]');
      if (element) finish(element);
    });
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
    } else {
      initialise();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
